import React, { useState, createContext } from "react";

export const DeveloperUuidContext = createContext();
/*
export const AppShopContext = createContext({
  isAppShop: false,
  setIsAppShop: () => { },
});
*/
export const DeveloperUuidContextProvider = (props) => {
  const [developerUuId, setDeveloperUuId] = useState();
  const [authority, setAuthority] = useState();

  return (
    <DeveloperUuidContext.Provider
      value={{
        developerUuId, setDeveloperUuId,
        authority, setAuthority
      }}
    >
      {props.children}
    </DeveloperUuidContext.Provider>
  )
}